<script>
  import AXHR from "../components/js/axhr.js";
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  //FORM SECTION

  import QrCode from "svelte-qrcode";
  import format from "number-format.js";
  $: profileFiltered = [];
  function loadprofileData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      profileFiltered = res;
    });
  }

  function onLoginDetail(prof, get, pure = false) {
    let strings = profileFiltered
      .filter((el) => {
        return el["name"] == prof;
      })[0]
      ["onLogin"].split(",");
    if (get == 1) {
      if (pure == true) {
        strings = strings[1];
      } else {
        if (strings[1] == "rem") {
          strings = "Remove";
        } else if (strings[1] == "ntf") {
          strings = "Notice";
        } else if (strings[1] == "remc") {
          strings = "Remove & Record";
        } else if (strings[1] == "ntfc") {
          strings = "Notice & Record";
        } else {
          strings = "";
        }
      }
    } else if (get == 2) {
      strings = strings[2];
    } else if (get == 3) {
      strings = strings[3];
    } else if (get == 4) {
      strings = strings[4];
    } else if (get == 5) {
      strings = strings[5];
    }
    return strings;
  }
  $: serverFiltered = [];
  function loadserverData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      serverFiltered = res;
    });
  }
  if (sessions) {
    loadprofileData(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-user-profile",
      sessions.token,
      false
    );
    loadserverData(
      sessions.api + "/rb/" + sessions.routeractive.id + "/ip-hotspot",
      sessions.token,
      false
    );
  }
  let loading = false;

  let payload;
  $: payload = {
    qty: "",
    server: "all",
    usertype: "",
    str_length: "",
    char: "",
    prefix: "",
    profile: "",
    timelimit: "",
    datalimit: "",
    mbgb: "MB",
    comment: "",
  };

  let require;

  $: require = {
    qty: payload.qty,
    server: payload.server,
    usertype: payload.usertype,
    str_length: payload.str_length,
    char: payload.char,
    profile: payload.profile,
  };
  let number;
  $: number = {
    datalimit: payload.datalimit,
  };

  let email;
  $: email = {};
  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        if (require[n] != undefined || number[n] != "") {
          errorForm = [
            ...errorForm,
            { field: n, message: "Pastikan Hanya Angka" },
          ];
        }
        if (number[n] !== "") {
          if (document.getElementById(n + "-warning")) {
            document.getElementById(n + "-warning").style.display =
              "inline-block";
            document.getElementById(n + "-warning").innerHTML =
              "Pastikan Hanya Angka";
          }
          if (document.getElementById(n + "-labelwarning")) {
            document.getElementById(n + "-labelwarning").style.color =
              "rgb(255, 102, 102)";
          }
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        if (require[e] != undefined || email[e] !== "") {
          errorForm = [
            ...errorForm,
            { field: e, message: "Pastikan Email sudah tepat" },
          ];
        }
        if (email[e] !== "") {
          if (document.getElementById(e + "-warning")) {
            document.getElementById(e + "-warning").style.display =
              "inline-block";
            document.getElementById(e + "-warning").innerHTML =
              "Pastikan Email sudah tepat";
          }
          if (document.getElementById(e + "-labelwarning")) {
            document.getElementById(e + "-labelwarning").style.color =
              "rgb(255, 102, 102)";
          }
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  import Modal from "../components/Modal.svelte";
  import prettyB from "pretty-bytes";
  let dataFiltered = [];
  let loadTable = false;
  let success;
  $: success = false;
  function handleSubmit() {
    let data;
    let method = "post";
    data = {
      qty: payload.qty,
      server: payload.server,
      usertype: payload.usertype,
      str_length: payload.str_length,
      char: payload.char,
      prefix: payload.prefix,
      profile: payload.profile,
      timelimit: payload.timelimit,
      datalimit: payload.datalimit,
      mbgb: payload.mbgb,
      comment: payload.comment,
    };
    loading = true;
    let valid;
    valid = validator();
    if (valid) {
      var config = {
        method: method,
        url:
          sessions.api +
          "/rb/" +
          sessions.routeractive.id +
          "/hotspot/user/generate",
        headers: {
          Authorization: "Bearer " + sessions.token,
          "Content-Type": "application/json",
        },
        data: data,
      };

      AXHR(config)
        .then(function (response) {
          dataFiltered = response.data;
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "Perintah berhasil dieksekusi",
              color: "green",
            },
          ];
          success = true;
          loading = false;

          loadTable = true;
          setTimeout(() => {
            success = false;
            payload = {
              qty: "",
              server: "all",
              usertype: "",
              str_length: "",
              char: "",
              prefix: "",
              profile: "",
              timelimit: "",
              datalimit: "",
              mbgb: "MB",
              comment: "",
            };
          }, 5000);
        })
        .catch(function (error) {
          success = false;
          loading = false;

          document.getElementById("formAddHotspotUser").classList.add("shake");
          setTimeout(() => {
            document
              .getElementById("formAddHotspotUser")
              .classList.remove("shake");
          }, 2500);
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      console.log(valid);
      console.log(errorForm);
      success = false;
      loading = false;
      document.getElementById("formAddHotspotUser").classList.add("shake");
      setTimeout(() => {
        document.getElementById("formAddHotspotUser").classList.remove("shake");
      }, 2500);
    }
  }

  let selection = [];
  let selectionUser = [];
  let deleteSelected = false;

  $: console.log(selectionUser);
  $: if (selection.length > 0) {
    document.getElementById("selectAll").indeterminate = true;
    if (selection.length === dataFiltered.length) {
      setTimeout(() => {
        document.getElementById("selectAll").indeterminate = false;
      }, 100);
      document.getElementById("selectAll").checked = true;
    }
    deleteSelected = true;
  } else if (selection.length === 0) {
    setTimeout(() => {
      if (document.getElementById("selectAll")) {
        document.getElementById("selectAll").indeterminate = false;
      }
    }, 200);
    deleteSelected = false;
  }
  function SelectAll(state, css) {
    for (var i = 0; i < dataFiltered.length; i++) {
      if (document.getElementsByClassName(css)[i]) {
        document.getElementsByClassName(css)[i].checked = state;
        if (state == true) {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;
          selection = [
            ...selection,
            document.getElementsByClassName(css)[i].value,
          ];

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
          selectionUser = [
            ...selectionUser,
            document.getElementsByClassName(css)[i].getAttribute("data-user"),
          ];
        } else {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
        }
      }
    }
  }

  function SelectData(e) {
    if (e.target.checked == true) {
      console.log("kclas");
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;
      selection = [...selection, e.target.value];

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
      selectionUser = [...selectionUser, e.target.dataset.user];
    } else {
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
    }
  }
  function deleteSelectedUser(selection) {
    loading = true;
    let data = {
      selection: selection,
    };

    var config = {
      method: "delete",
      url:
        sessions.api + "/rb/" + sessions.routeractive.id + "/hotspot/user/mass",
      headers: {
        Authorization: "Bearer " + sessions.token,
        "Content-Type": "application/json",
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        setTimeout(() => {
          document.getElementById("selectAll").indeterminate = false;
        }, 100);
        document.getElementById("selectAll").checked = false;
        SelectAll(false, "idUser");
        if (response.data.length != undefined) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.length + " User Berhasil dihapus",
              color: "green",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "User " + response.data.name + " Berhasil dihapus",
              color: "green",
            },
          ];
        }
        loading = false;
        loadData(
          sessions.api + "/rb/" + sessions.routeractive.id + "/ip-hotspot-user",
          sessions.token,
          { name: "default", value: true }
        );
      })
      .catch(function (error) {
        loading = false;
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }

  import MakeSortable from "../components/MakeTable/MakeSortable.svelte";
  import SortHeader from "../components/MakeTable/SortHeader.svelte";
  let filter = "",
    imgsortIconCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>',
    imgsortIconAscCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path></svg>',
    imgsortIconDescCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" /></svg>';
</script>

<svelte:head>
  <title>Mikhub - Hotspot User Cenerator</title>
</svelte:head>
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-24 mx-auto mb-20 lg:pt-24 md:pt-20"
>
  {#if loadTable}
    <Title
      title="Generator Results"
      subtitle="List of Generator Results Users"
      tipe="3"
      href="./"
    />
    <MakeSortable
      rowsPerPage="1000"
      data={dataFiltered}
      let:table
      {filter}
      filterFields={[
        "addressPool",
        "name",
        "parentQueue",
        "rateLimit",
        "sharedUsers",
        "onLogin",
        "comment",
        "limitUptime",
      ]}
      sortIconCss={imgsortIconCss}
      sortIconAscCss={imgsortIconAscCss}
      sortIconDescCss={imgsortIconDescCss}
    >
      <div class="flex flex-wrap items-center justify-between w-full my-2">
        <div class="flex justify-start w-1/2 gap-2 py-1 lg:w-4/12 md:w-2/6">
          <div class="mt-0 lg:mt-0 md:mt-4">
            <button
              on:click={() => (loadTable = false)}
              class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
              ><svg
                class="inline w-4 h-4"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  points="3.828 9 9.899 2.929 8.485 1.515 0 10 .707 10.707 8.485
                  18.485 9.899 17.071 3.828 11 20 11 20 9 3.828 9"
                />
              </svg> Back</button
            >
          </div>
          {#if table.pageRows.length > 0}
            <div class="mt-0 lg:mt-0 md:mt-4">
              <button
                on:click={() => window.print()}
                class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
                ><svg
                  class="inline w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                  />
                </svg>
                Print</button
              >
            </div>
          {/if}
        </div>
        <div
          class="flex items-center justify-end w-1/2 gap-4 px-2 py-1 text-xs lg:w-4/12 md:w-2/6"
        >
          <span>Total : <b>{table.rows.length}</b></span><span
            >Filtered : <b>{table.sortedAndFilteredRows.length}</b></span
          >
        </div>
        <input
          type="text"
          class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
          placeholder="Search..."
          bind:value={filter}
        />
      </div>
      <div class="flex flex-wrap items-center justify-between w-full mb-2">
        {#if table.pageRows.length > 0}
          <div class="flex flex-wrap w-full" id="kpt">
            {#each table.pageRows as d, i}
              <div
                class="relative w-1/2 p-px mb-2 lg:w-1/5 md:w-1/5 sm:w-1/5 vc"
              >
                <div
                  class="w-full overflow-hidden bg-white border-2 border-gray-600 border-dotted rounded-lg"
                >
                  <div class="relative flex flex-wrap w-full">
                    <div class="w-6/12 px-2">
                      <h2 class="font-bold text-gray-900 text-md">
                        {#if sessions.routeractive.logo}
                          <img
                            src="{sessions.api}/logo/{sessions.routeractive
                              .logo}"
                            alt={sessions.routeractive.name}
                            class="w-full"
                          />
                        {:else}
                          {sessions.routeractive.name}
                        {/if}
                      </h2>
                    </div>
                    <div class="w-6/12 text-right">
                      <span
                        class="inline-block px-1 py-0 text-xs italic font-bold text-gray-800 bg-gray-100 border border-r-0 border-gray-500 rounded-l-lg"
                      >
                        {format("Rp#.##0,", onLoginDetail(d.profile, 4))}
                        <span /></span
                      >
                    </div>
                  </div>
                  <div class="relative flex flex-wrap w-full h-24">
                    <div class="w-8/12 px-2 text-xs">
                      <h3 class="text-xs font-bold">
                        <span class="italic font-normal">Valid for</span>

                        {#if onLoginDetail(d.profile, 3) !== ""}
                          {onLoginDetail(d.profile, 3)}
                        {:else}
                          Forever
                        {/if}
                      </h3>
                      <h3 class="text-xs font-bold">
                        {#if d.limitBytesTotal}
                          {prettyB(d.limitBytesTotal)}
                        {:else}
                          Unlimited
                        {/if}
                        <span class="italic font-normal">Quota </span>
                      </h3>
                      {#if d.password !== d.name}
                        <h4
                          class="px-1 font-mono text-sm font-bold text-center text-black bg-white border border-gray-900 border-dashed rounded"
                        >
                          {String(d.name)}
                        </h4>

                        <h4
                          class="px-1 mt-px font-mono text-sm font-bold text-center text-black bg-white border border-gray-500 border-dashed rounded"
                        >
                          {String(d.password)}
                        </h4>
                      {:else}
                        <h4
                          class="flex items-center justify-center px-1 font-mono text-sm font-bold leading-3 text-center text-black bg-white border border-gray-900 border-dashed rounded h-7"
                        >
                          {String(d.name)}
                        </h4>
                      {/if}
                    </div>
                    <div
                      class="flex items-center justify-end w-4/12 p-1 bg-white rounded"
                    >
                      <QrCode
                        value="http://{sessions.routeractive
                          .dns}/login?username={d.name}&password={d.password}"
                        size="256"
                      />
                    </div>
                  </div>

                  <div
                    class="w-full h-5 px-2 text-xs italic leading-3 text-gray-900 truncate"
                  >
                    login : http://{sessions.routeractive.dns}
                  </div>
                  <div
                    class="relative flex flex-wrap w-full mt-px bg-gray-100 border-t border-gray-400 border-dashed"
                  >
                    <div
                      class="items-center w-full h-4 px-2 py-0 text-xs italic text-gray-900 truncate whitespace-pre-wrap"
                    >
                      <h4>[{i + 1}] {String(d.comment)}</h4>
                    </div>
                  </div>
                </div>
              </div>
            {/each}
          </div>
        {:else}
          {#if filter}
            <div class="flex items-center justify-center w-full h-full">
              <div class="text-center">
                <span class="italic text-gray-900 animate-pulse text-md"
                  >Data Not Found</span
                >
              </div>
            </div>
          {:else}
            <div class="flex items-center justify-center w-full h-full">
              <div class="text-center">
                <span class="italic text-gray-900 animate-pulse text-md"
                  >Data Not Found</span
                >
              </div>
            </div>
          {/if}

          <div class="flex items-center justify-center w-full h-full">
            <div class="text-center">
              <img
                src="./assets/logo/logo_icon.svg"
                alt="Mikhub Loading"
                class="w-20 h-20 mx-auto animate-spin"
                width="50"
                height="50"
              />
            </div>
          </div>
        {/if}
      </div>
    </MakeSortable>
  {:else}
    <Title
      title="Hotspot User Generator"
      subtitle="Generate Your Hotspot Users"
      tipe="3"
      href="./"
    />
    <div class="mx-auto my-2 lg:my-2">
      <div class="relative block w-full gap-8 lg:flex md:block">
        <!--FORM SECTION-->
        <div
          class="fixed bottom-0 right-0 z-10 block w-20 mb-20 mr-5 lg:z-auto md:z-auto lg:hidden md:block lg:right-0 lg:bottom-0 lg:mt-0 lg:mr-5"
        >
          <a
            href="./hotspot-user-generate"
            on:click|preventDefault={() => {
              document
                .getElementById("formAddHotspotUser")
                .classList.remove("hidden");
              document
                .getElementById("formAddHotspotUser")
                .classList.add("block");
              payload = {
                qty: "",
                server: "all",
                usertype: "",
                str_length: "",
                char: "",
                prefix: "",
                profile: "",
                timelimit: "",
                datalimit: "",
                mbgb: "MB",
                comment: "",
              };
            }}
            class="flex items-center justify-center w-20 h-10 text-xs text-center text-white bg-blue-600 rounded-full shadow-md lg:w-auto md:w-auto active:bg-gray-500 focus:outline-none hover:bg-blue-400"
            >Open Generator</a
          >
        </div>
        <div
          id="formAddHotspotUser"
          class="fixed top-0 left-0 right-0 z-50 hidden w-full h-screen p-5 py-0 my-0 overflow-y-auto bg-white rounded-none shadow-lg lg:overflow-y-none md:overflow-y-auto lg:h-full md:h-screen lg:block lg:py-5 md:py-5 lg:z-auto md:z-50 lg:my-5 md:my-0 lg:rounded-lg md:rounded-lg lg:w-3/12 md:w-full lg:sticky md:fixed"
        >
          <div
            class="h-auto pt-0 pb-20 md:pt-0 lg:pb-0 md:pb-b lg:h-auto md:h-auto lg:pt-0"
          >
            <div class="sticky top-0 z-10 lg:z-0 md:z-10 lg:block md:block">
              <Title
                title="Generator"
                subtitle="Generate User Quickly"
                tipe="1"
              />
            </div>

            {#if success}
              <div class="w-full" on:click={() => (success = false)}>
                <div
                  class="w-full p-2 mx-auto mb-2 text-xs bg-gray-300 border-4 border-t border-b border-r border-gray-600 border-solid rounded shadow-lg color-white"
                >
                  <h2
                    class="relative flex items-center justify-between text-sm font-bold"
                  >
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        class="inline-block w-4 h-4"
                      >
                        <path
                          d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0 1 16 8v6l3
              2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z"
                        />
                      </svg>
                      Berhasil
                    </span>
                    <span
                      class="absolute top-0 right-0 -mt-2 text-sm font-bold text-gray-700"
                      on:click={() => (success = false)}>x</span
                    >
                  </h2>
                  <p>
                    Kamu berhasil {#if payload.id != false}
                      Menggubah
                    {:else}
                      Menambah
                    {/if} user di server {sessions.routeractive.name}
                  </p>
                </div>
              </div>
            {/if}

            <form
              class="px-2 pt-2"
              autocomplete="off"
              on:submit|preventDefault={handleSubmit}
              id="quickAddHotspotUser"
            >
              <section class="mt-5">
                <label for="qty" class="relative block text-sm font-light">
                  <input
                    class="w-32 rounded-lg form-input"
                    name="qty"
                    id="qty"
                    autocomplete="off"
                    type="number"
                    min="1"
                    max="1000"
                    step="1"
                    placeholder="Quantity"
                    bind:value={payload.qty}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="qty-labelwarning"
                    >Quantity
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="qty-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label for="server" class="relative block text-sm font-light">
                  <select
                    class="w-full rounded-lg form-input"
                    name="server"
                    id="server"
                    placeholder="Hotspot Server"
                    bind:value={payload.server}
                  >
                    <option value="all">all</option>
                    {#each serverFiltered as p}
                      <option value={p.name}>{p.name}</option>
                    {/each}
                  </select>
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="server-labelwarning"
                    >Hotspot Server
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="server-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label for="usertype" class="relative block text-sm font-light">
                  <select
                    class="w-full rounded-lg form-input"
                    name="usertype"
                    id="usertype"
                    placeholder="Hotspot usertype"
                    bind:value={payload.usertype}
                  >
                    <option />
                    <option value="vc">Username=Password</option>
                    <option value="up">Username & Password</option>
                  </select>
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="usertype-labelwarning"
                    >User Type
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="usertype-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label
                  for="str_length"
                  class="relative block text-sm font-light"
                >
                  <input
                    class="w-32 rounded-lg form-input"
                    name="str_length"
                    id="str_length"
                    autocomplete="off"
                    type="number"
                    min="1"
                    max="20"
                    step="1"
                    placeholder="Char Length"
                    bind:value={payload.str_length}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="str_length-labelwarning"
                    >Char Length
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="str_length-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label for="prefix" class="relative block text-sm font-light">
                  <input
                    class="w-32 rounded-lg form-input"
                    name="prefix"
                    id="prefix"
                    autocomplete="off"
                    type="text"
                    placeholder="Prefix"
                    bind:value={payload.prefix}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="prefix-labelwarning"
                    >Prefix
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="prefix-warning"
                  />
                </label>
              </section>
              <section class="mt-5">
                <label for="char" class="relative block text-sm font-light">
                  <select
                    class="rounded-lg w-52 form-input"
                    name="char"
                    id="char"
                    autocomplete="off"
                    type="text"
                    placeholder="char"
                    bind:value={payload.char}
                  >
                    <option value="" />
                    <option value="au">ABCDEFG</option>
                    <option value="al">abcdefgh</option>
                    <option value="a">aBcDeFgH</option>
                    <option value="anl">abcd1234</option>
                    <option value="anu">ABCD1234</option>
                    <option value="an">aBcD1234</option>
                    <option value="n">12345678</option>
                  </select>
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="char-labelwarning"
                    >Character
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="char-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label for="profile" class="relative block text-sm font-light">
                  <select
                    class="w-full rounded-lg form-input"
                    name="profile"
                    id="profile"
                    autocomplete="off"
                    type="text"
                    placeholder="profile"
                    bind:value={payload.profile}
                  >
                    <option value="" />
                    {#each profileFiltered as p}
                      <option value={p.name}>{p.name}</option>
                    {/each}
                  </select>
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="profile-labelwarning"
                    >Profile
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="profile-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label
                  for="timelimit"
                  class="relative block text-sm font-light"
                >
                  <input
                    class="w-32 rounded-lg form-input"
                    name="timelimit"
                    id="timelimit"
                    autocomplete="off"
                    type="text"
                    placeholder="Time Limit"
                    bind:value={payload.timelimit}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="timelimit-labelwarning"
                    >Time Limit
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="timelimit-warning"
                  />
                  <p class="text-xs text-right text-gray-500">
                    ex: 30d = 30hari, 12h = 12jam, 4w3d = 31hari
                  </p>
                </label>
              </section>
              <section class="flex gap-2 mt-5">
                <label
                  for="datalimit"
                  class="relative block w-7/12 text-sm font-light"
                >
                  <input
                    class="w-full rounded-lg form-input"
                    name=""
                    id="datalimit"
                    autocomplete="off"
                    type="text"
                    placeholder="Quota"
                    bind:value={payload.datalimit}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="datalimit-labelwarning"
                    >Quota
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="datalimit-warning"
                  />
                </label>
                <label
                  for="mbgb"
                  class="relative block w-5/12 text-sm font-light"
                >
                  <select
                    class="w-full rounded-lg form-input"
                    name="mbgb"
                    id="mbgb"
                    autocomplete="off"
                    type="text"
                    placeholder="mbgb"
                    bind:value={payload.mbgb}
                  >
                    <option>MB</option>
                    <option>GB</option>
                  </select>
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="mbgb-labelwarning"
                    >MB/GB
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="profile-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label for="comment" class="relative block text-sm font-light">
                  <input
                    class="w-full rounded-lg form-input"
                    name="comment"
                    id="comment"
                    autocomplete="off"
                    type="text"
                    placeholder="Comment"
                    bind:value={payload.comment}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="comment-labelwarning"
                    >Comment
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="comment-warning"
                  />
                </label>
              </section>
              <div
                class="flex justify-between w-full gap-2 lg:justify-between md:justify-start"
              >
                {#if loading}
                  <button
                    type="submit"
                    class="w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                    disabled="disabled"
                  >
                    MEMPROSES...
                  </button>
                {:else}
                  <button
                    type="submit"
                    class="w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                    on:click={handleSubmit}
                  >
                    SAVE
                  </button>
                {/if}

                <button
                  type="button"
                  on:click|preventDefault={() => {
                    document
                      .getElementById("formAddHotspotUser")
                      .classList.remove("block");
                    document
                      .getElementById("formAddHotspotUser")
                      .classList.add("hidden");
                  }}
                  class="block w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg lg:hidden md:block text-1xl active:bg-gray-500 focus:outline-none"
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  on:click|preventDefault={() => {
                    payload = {
                      server: "all",
                      usertype: "",
                      prefix: "",
                      profile: "",
                      timelimit: "",
                      datalimit: "",
                      mbgb: "MB",
                      comment: "",
                    };
                  }}
                  class="hidden w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg lg:block md:hidden text-1xl active:bg-gray-500 focus:outline-none"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
        </div>

        <div
          class="w-full px-2 py-5 pb-2 my-5 bg-white rounded-lg shadow-lg lg:w-9/12 md:w-full"
        >
          <div class="flex items-center justify-center w-full h-full">
            <div class="py-10 text-center">
              <h3 class="text-xl font-bold">Generator Is Ready</h3>
              Use the generator to start your magic
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</main>

{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-50 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
